import React from 'react';
import { getLocalUserInfoLocalStorage } from "../utils/utils";
import { statuses } from "../utils/utils";
import { translate } from "../utils/translation";

function Trade(props) {
    const { customerDetailsTradeInfo, trades } = props;
    const {
        storeIds, storeNames, showStoreName,
        showCustomerId, showCustomerFirstName, showCustomerLastName,
        showWaitTime, defaultLanguage
    } = getLocalUserInfoLocalStorage();
    const language = defaultLanguage || 'en';
    const storeInfo = {};
    storeIds.map((storeId, index) => storeInfo[storeId] = storeNames[index]);

    const setCSSColor = (status) => {
        let titleClassName = 'preparing';
        switch (status) {
            case statuses[0]:
                titleClassName = 'preparing';
                break;
            case statuses[1]:
                titleClassName = 'collect';
                break;
            default:
                break;
        }
        return titleClassName;
    };

    // const word = (num) => {
    //     const numPeople = parseInt(num);
    //     if (numPeople === 1) {
    //         return 'person';
    //     }
    //     return 'people';
    // };

    return (
        <>
            {trades.length !== 0 && trades.map((trade, index) => {
                return (
                    <div
                        key={index}
                        className={`trade ` + setCSSColor(props.status)}>
                        <div className="text-center p-2 font-weight-light square-centre">
                            {showStoreName ? <div>{storeInfo[trade.storeId]}</div> : ''}
                            {customerDetailsTradeInfo && (showCustomerFirstName || showCustomerLastName) ?
                                <div className="order-name">
                                    {(showCustomerFirstName && customerDetailsTradeInfo[trade.id]?.firstName)} {showCustomerLastName && customerDetailsTradeInfo[trade.id]?.lastName}
                                </div> : ''
                            }

                            {customerDetailsTradeInfo && showCustomerId ?
                                <div>{translate('CUSTOMER_ID', language)}: {customerDetailsTradeInfo[trade.id]?.customerId}</div> : ''}

                            <div className={"order-id"}>
                                {trade.orderCallNumber || trade.pagerIdentifier || trade.id}
                            </div>

                            {customerDetailsTradeInfo && props.status === statuses[0] && showWaitTime ?
                                <div>{translate('WAIT_TIME', language)}: {parseInt(customerDetailsTradeInfo[trade.id]?.waitTime)} {translate('MINUTES', language)}</div> : ''}
                            {/*{peopleAhead && props.status === statuses[0] && customerDetailsTradeInfo ?*/}
                                {/*`${customerDetailsTradeInfo[trade.id]?.numPeopleAhead } ${word(customerDetailsTradeInfo[trade.id]?.numPeopleAhead)} ahead of you in the queue` : ''}*/}
                        </div>
                    </div>
                )
            })}
        </>
    );
}

export default Trade;
